<template>
    <div class="recharge-container">
        <div class="content-wrapper">
            <div class="qr-box">
                <div class="qr-content">
                    <vue-qr :logoSrc="qrPath" :text="props.address" :size="size" :quality="quality" :colorDark="'#000'"
                        :colorLight="'#fff'">
                    </vue-qr>
                </div>
            </div>

            <div class="address-section">
                <div class="label">{{ $t('recharge.Address') }}</div>
                <van-row class="custom-field">
                    <van-col span="19" class="ellipsis-text">{{ props.address }}</van-col>
                    <van-col span="5">
                        <van-button size="small" type="primary" class="copy-btn" @click="onCopy">
                            {{ $t('recharge.CopyLink') }}
                        </van-button>
                    </van-col>
                </van-row>
            </div>

            <div class="info-grid">
                <div class="info-item">
                    <span class="info-label">{{ $t('recharge.mainNet') }}</span>
                    <span class="info-value">{{ props.typeTitle }}</span>
                </div>
                <div class="info-item text-right">
                    <span class="info-label">{{ $t('recharge.chargingRange') }}</span>
                    <span class="info-value highlight">{{ props.minAmount }} - {{ props.maxAmount }} USDT</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { ref } from 'vue';
import { showToast } from 'vant';
import 'vant/es/toast/style';
import VueQr from 'vue-qr/src/packages/vue-qr.vue';
const props = defineProps({
    address: {
        type: String,
        default: ''
    },
    minAmount: {
        type: String,
        default: ''
    },
    maxAmount: {
        type: String,
        default: ''
    },
    typeTitle: {
        type: String,
        default: ''
    }
})
const qrPath = ref('')
const size = ref(200)
const quality = ref('H')
const onCopy = () => {
    navigator.clipboard.writeText(props.address);
    showToast('Address Copied');
};
</script>

<style scoped>
.recharge-container {
    display: flex;
    justify-content: center;
    padding: 20px;
}

.content-wrapper {
    width: 100%;
    border-radius: 10px;
    padding: 20px;
    background: linear-gradient(145deg, #012f2e, #001b1b99);
    /* box-shadow: 0 8px 30px rgba(0, 0, 0, 0.6); */
}

.qr-box {
    display: flex;
    justify-content: center;
    margin-bottom: 25px;
}

.qr-content {
    padding: 18px;
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.08);
    backdrop-filter: blur(0px);
    box-shadow: 0 0 5px rgba(0, 255, 200, 0.15);
}

.address-section .label {
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 8px;
    color: #b2dfdb;
}

.custom-field {
    background: #002121 !important;
    border: 1px solid rgba(0, 255, 200, 0.3);
    border-radius: 10px;
    color: #fff;
    font-family: monospace;
    font-size: 14px;
    height: 45px;
    display: flex;
    align-items: stretch; 
    overflow: hidden; 
}

.custom-field .van-col {
    height: 100%;
    display: flex;
    align-items: center;
}

.copy-btn {
    background: linear-gradient(90deg, #00c9a7, #00e4c5);
    border: none;
    height: 100%;
    width: 100%;
    border-radius: 0; 
    font-size: 13px;
    font-weight: 600;
    color: #003333;
    display: flex;
    align-items: center;
    justify-content: center;
}

.copy-btn:active {
    transform: scale(0.95);
    opacity: 0.8;
}

.info-grid {
    display: flex;
    justify-content: space-between;
    margin-top: 25px;
    padding: 15px;
    border-radius: 10px;
    background: rgba(0, 255, 200, 0.05);
}

.info-item {
    display: flex;
    flex-direction: column;
}

.info-label {
    color: #80cbc4;
    font-size: 13px;
    margin-bottom: 4px;
}

.info-value {
    font-weight: 600;
    font-size: 15px;
    color: #ffffff;
}

.highlight {
    color: #00e4c5;
}

.ellipsis-text {
    white-space: nowrap;
    overflow-x: auto;
    display: flex;
    align-items: center;
    padding-right: 8px;
    scrollbar-width: none;
}

.ellipsis-text::-webkit-scrollbar {
    display: none;
}

/* MOBILE */
@media (max-width: 360px) {
    .custom-field {
        font-size: 11px;
        height: 36px;
    }

    .info-label {
        font-size: 12px;
    }

    .info-value {
        font-size: 13px;
    }
}
</style>